import { useSelectedEnvironmentKey } from '@gonfalon/app-context/useSelectedEnvironmentKey';
import http from '@gonfalon/legacy-http-client/httpUtils';
import { useProjectKey } from '@gonfalon/router/useProjectKey';
import { useQuery } from '@tanstack/react-query';

import { useSelector } from '#hooks/useSelector';
import { experimentFilterSelector, experimentListSelector, experimentRequestSelector } from '#reducers/experiments';
import { ready } from '#utils/reduxUtils';

export function useHasLegacyExperiments(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;

  const projKey = useProjectKey();
  const envKey = useSelectedEnvironmentKey();

  const experiments = useSelector(experimentListSelector);
  const experimentsFilter = useSelector(experimentFilterSelector);
  const experimentsRequest = useSelector(experimentRequestSelector);

  const isExperimentsFiltered = Boolean(experimentsFilter.query || experimentsFilter.status);

  const { data: hasLegacyExperiments, isPending } = useQuery({
    queryKey: ['HAS_LEGACY_EXPERIMENTS', projKey, envKey],
    queryFn: () =>
      http
        .get(`/internal/experiments/${projKey}/${envKey}?limit=1`)
        .then((response) => response.json())
        .then((response) => response.totalCount > 0),
    enabled,
  });

  // If we already have data from the query hook, just use that
  if (typeof hasLegacyExperiments !== 'undefined' && !isPending) {
    return { hasLegacyExperiments, isLoading: isPending };
  } else if (!isExperimentsFiltered && ready(experimentsRequest)) {
    return {
      hasLegacyExperiments: enabled && ready(experimentsRequest) ? experiments.size > 0 : undefined,
      isLoading: enabled ? !ready(experimentsRequest) : false,
    };
  }

  return { hasLegacyExperiments, isLoading: isPending };
}
